<div class="detail">
  <button type="button" class="detail-close" (click)="onClose()" [attr.aria-label]="'common_btn_close' | translate">
    <mat-icon>close</mat-icon>
  </button>

  <div class="detail-header">
    <div class="detail-avatar">{{ data.prenom?.charAt(0) }}{{ data.nom?.charAt(0) }}</div>
    <div class="detail-heading">
      <h4 class="detail-name">{{ data.prenom }} {{ data.nom }}</h4>
      <div class="detail-sub">
        <span class="profile-badge" [ngClass]="'profile-' + data.profileType"> <span class="profile-dot"></span>{{ profileLabel(data.profileType) }} </span>
        <span class="detail-subtitle">{{ 'validation_dialog_subtitle' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="detail-content">
    <h5 class="section-title">{{ 'validation_section_personal' | translate }}</h5>
    <div class="field-grid">
      <div class="field">
        <span class="field-label">{{ 'validation_field_email' | translate }}</span>
        <span class="field-value">{{ data.email }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_fonction' | translate }}</span>
        <span class="field-value">{{ data.fonction || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_creation_date' | translate }}</span>
        <span class="field-value">{{ data.creationDate | localizedDate: 'shortDate' }}</span>
      </div>
    </div>

    <h5 class="section-title">{{ 'validation_section_professional' | translate }}</h5>
    <div class="field-grid">
      <div class="field">
        <span class="field-label">{{ 'validation_field_organisation' | translate }}</span>
        <span class="field-value">{{ data.organisation || '—' }}</span>
        <span class="new-org-tag" *ngIf="!data.memberId">{{ 'validation_new_organisation' | translate }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_referent_email' | translate }}</span>
        <span class="field-value">{{ data.referentEmails || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_pays' | translate }}</span>
        <span class="field-value">{{ countryLabel(data.pays) }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_siren' | translate }}</span>
        <span class="field-value">{{ data.siren || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_adhesion' | translate }}</span>
        <span class="field-value">{{ adhesionLabel(data.adhesion) }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_numero_tp' | translate }}</span>
        <span class="field-value">{{ data.numeroTp || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_adresse' | translate }}</span>
        <span class="field-value">{{ data.adresse || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_code_postal' | translate }}</span>
        <span class="field-value">{{ data.codePostal || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_ville' | translate }}</span>
        <span class="field-value">{{ data.ville || '—' }}</span>
      </div>
      <div class="field">
        <span class="field-label">{{ 'validation_field_cgu' | translate }}</span>
        <span class="field-value">{{ (data.cgu ? 'validation_yes' : 'validation_no') | translate }}</span>
      </div>
    </div>
  </div>

  <div class="detail-actions" *ngIf="!confirmingRefusal; else refusalConfirmation">
    <button type="button" class="btn-refuse" (click)="askRefusal()"><mat-icon>close</mat-icon>{{ 'validation_action_refuse' | translate }}</button>
    <button type="button" class="btn-accept" (click)="onAccept()"><mat-icon>check</mat-icon>{{ 'validation_action_accept' | translate }}</button>
  </div>

  <ng-template #refusalConfirmation>
    <p class="refusal-question">{{ 'validation_refuse_question' | translate: { name: data.prenom + ' ' + data.nom } }}</p>
    <div class="detail-actions">
      <button type="button" class="btn-cancel" (click)="cancelRefusal()">{{ 'common_cancel' | translate }}</button>
      <button type="button" class="btn-refuse-confirm" (click)="onRefuse()"><mat-icon>close</mat-icon>{{ 'validation_refuse_confirm' | translate }}</button>
    </div>
  </ng-template>
</div>
